import React from 'react';

const Navbar = ({ isSolid, onContactClick }) => {
  const handleContactClick = (e) => {
    e.preventDefault();
    onContactClick(e);
  };

  return (
    <nav id="nav" className={isSolid ? 'solid' : ''}>
      <a href="/" className="nav-logo">
        <div className="logo-sq">SR</div>
        <span className="logo-name">SSRR <b>Labs</b></span>
      </a>
      <ul className="nav-links">
        <li><a href="#build">What We Build</a></li>
        <li><a href="#deliver">Services</a></li>
        <li><a href="#why">Why Us</a></li>
        <li><a href="#capabilities">Capabilities</a></li>
      </ul>
      <a href="#contact" className="nav-btn" onClick={handleContactClick}>Work With Us</a>
    </nav>
  );
};

export default Navbar;